import { render, staticRenderFns } from "./exhibition-business-match.vue?vue&type=template&id=3605afd5&scoped=true&"
import script from "./exhibition-business-match.vue?vue&type=script&lang=js&"
export * from "./exhibition-business-match.vue?vue&type=script&lang=js&"
import style0 from "./exhibition-business-match.vue?vue&type=style&index=0&id=3605afd5&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3605afd5",
  null
  
)

export default component.exports